import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  welcomeProfileContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    minHeight: 600
  },
  welcomeProfileContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  profileDataWrap: {
    marginBottom: '3.5rem',
  },
  welcomeText: {
    fontSize: 36,
    marginBottom: '1rem',
  },
  profileName: {
    fontSize: 39,
    marginBottom: '1rem',
  },
  profileLastName: {
    fontWeight: '500',
  },
  dobAgeText: {
    fontWeight: '500',
    marginBottom: '1rem',
  },
  dobText: {
    fontSize: 24,
    lineHeight: 1
  },
  ageText: {
    fontSize: 19,
    lineHeight: 1
  },
  courtText: {
    fontSize: 17,
    fontWeight: '500',
  },
  thanksParaWrap: {
    fontSize: 18,
    '& > p': {
      margin: '0 0 1rem 0'
    }
  },
  thanksHeadText: {
    fontWeight: '500',
  },
  continueBtn: {
    margin: '3.5rem 0 1rem 0'
  },
}));
